type TooltipPointerIconProps = {
  positionRules?: string
  fill?: string
}

export function TooltipPointerIcon({ positionRules, fill }: TooltipPointerIconProps) {
  const fillColor = fill ?? 'var(--surface-inverse-white-neutral)'

  return (
    <svg
      className={positionRules}
      xmlns='http://www.w3.org/2000/svg'
      width='7'
      height='16'
      viewBox='0 0 7 16'
      fill='none'
    >
      <path
        d='M3.13511 3.13511C5.04057 5.04057 5.99331 5.99331 6.24681 7.12743C6.37526 7.70205 6.37526 8.29795 6.24681 8.87257C5.99331 10.0067 5.04057 10.9594 3.1351 12.8649L-6.99382e-07 16L0 -3.49691e-07L3.13511 3.13511Z'
        fill={fillColor}
      />
    </svg>
  )
}
